import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { BudgetOwnerList } from '../../../../budget-settings/components/budget-settings-page/budget-settings-page.type';

export interface BudgetSettingsContext {
  isEditMode: boolean;
  accountOwnerId: number;
  ownersList: BudgetOwnerList[];
}

@Injectable({ providedIn: 'root' })
export class BudgetSettingsContextService {
  private contextSubject = new ReplaySubject<BudgetSettingsContext>(1);
  private currentContext: BudgetSettingsContext = null;

  setContext(ctx: BudgetSettingsContext): void {
    this.currentContext = ctx;
    this.contextSubject.next(ctx);
  }

  getContext(): BudgetSettingsContext {
    return this.currentContext;
  }

  getContext$(): Observable<BudgetSettingsContext> {
    return this.contextSubject.asObservable();
  }

  updateOwnersList(newOwners: BudgetOwnerList[]): void {
    if (this.currentContext) {
      this.setContext({
        ...this.currentContext,
        ownersList: newOwners
      });
    }
  }

  updateAccountOwnerId(newAccountOwnerId: number): void {
    if (this.currentContext) {
      this.setContext({
        ...this.currentContext,
        accountOwnerId: newAccountOwnerId
      });
    }
  }

  clearContext(): void {
    this.currentContext = null;
    this.contextSubject.next(null);
  }
}
